import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import ChannelSelection from './channel';
import ConfigUnits from './config-unit';
import SensorParameters from './sensor';

function ChannelConfig({onExit}) {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <ChannelSelection />},
    {id: 2, name: 'No', component: <SensorParameters />},
  ];

  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // const leftPress = useKeyPress('ArrowLeft');
  // const {onComponent} = useMenu();

  // useEffect(() => {
  //   if (!leftPress) return;

  //   onComponent(<ConfigUnits />);
  // }, [leftPress]);

  return (
    <SubMenuView
      title="Channel Configuration"
      menuItems={yesNoItem}
      content="Do you want to configure the channels?"
      onLeftCallback={() => onComponent(<ConfigUnits />)}
    />
  );
}
export default ChannelConfig;
